import styled from 'styled-components';
import { DESKTOP_MIN_BREAK, GTM_DATA_ATTRIBUTE } from '#/shared/constants';
import { InverseClearButton } from '#/shared/components/Styled';
import GTM_HANDLES from '#/shared/gtm-handles';
import tabSharedCss from '#/shared/css/tab';

export const RouteDirectionsTabsWrapper = styled.div`
  max-width: ${DESKTOP_MIN_BREAK};
  display: block;
`;

export const RouteDirectionsSelectorRow = styled.div`
  max-width: ${DESKTOP_MIN_BREAK};
  background-color: ${props => props.theme.tabBackgroundColor};
  display: flex;
  flex-flow: row;
`;

export const RouteDirectionSummaryRow = styled.div.attrs({ role: 'tablist' })`
  max-width: ${DESKTOP_MIN_BREAK};
  display: flex;
  flex-flow: row;
  color: ${props => props.theme.secondaryFontColor};
  background-color: ${props => props.theme.actionColor};
`;

export const RouteDirectionButton = styled(InverseClearButton).attrs(props => ({
  role: 'tab',
  [GTM_DATA_ATTRIBUTE]: `${GTM_HANDLES.route.routeDirectionButton}-${props.direction}`,
  'aria-selected': props.isActive,
}))`
  background-color: ${props => props.theme.tabBackgroundColor};
  font-size: 1em;
  padding: 10px 25px 10px 25px;
  flex: 1 1 auto;
  text-align: center;

  ${({ isActive, theme }) => tabSharedCss({ active: isActive, theme })}

  @media (any-hover: hover) {
    &:hover {
      background-color: ${props => props.theme.tabBackgroundColor};
      color: ${props => props.theme.tabActiveColor};
    }
  }
`;
